import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {IDrivingEvent} from "../../../models/IDrivingEvent";
import {drivingEventsAPI} from "../api";

interface FetchOptions {
    company_id: string;
    limit?: number;
    includeHeartbeats?: boolean;
}

export const fetchRecentDrivingEvents = createAsyncThunk<
    IDrivingEvent[],
    FetchOptions,
    { rejectValue: string }
>(
    'drivingEvents/fetchRecent',
    async ({company_id, limit = 100, includeHeartbeats = false}, {rejectWithValue}) => {
        try {
            return await drivingEventsAPI.getRecent(company_id, {limit, includeHeartbeats});
        } catch (err) {
            const msg = axios.isAxiosError(err)
                ? err.response?.data?.message ?? err.message
                : 'Failed to fetch driving events';
            return rejectWithValue(msg);
        }
    },
);